import { useEffect } from 'react';
var useAsyncClickout = function useAsyncClickout(_ref) {
  var externalUrl = _ref.externalUrl,
    trigger = _ref.trigger,
    onOpen = _ref.onOpen;
  useEffect(function () {
    if (externalUrl && trigger) {
      var newWindow = window.open(externalUrl, '_blank');
      if (!newWindow || newWindow.closed || newWindow.closed === 'undefined') {
        window.location.assign(externalUrl);
      }
      if (onOpen) onOpen();
    }
  }, [externalUrl, trigger, onOpen]);
};
export default useAsyncClickout;